import wiredImg from './images/wired.png';
import giornalettismoImg from './images/giornalettismo.svg';
import siViaggiaImg from './images/siViaggia.png';
import donnaGlamourImg from './images/donnaglamour.png';
import viaggioOffImg from './images/viaggioOff.jpg';
import techPrincessImg from './images/techprincess.svg';
import imbruttitoImg from './images/imbruttito.svg';
import vanityFair from './images/vanityFair.png';
import quotidianoDeSiciliaImg from './images/quotidianoDeSicilia.png';
import ramingareImg from './images/ramingare.png';
import travelFashionTipsImg from './images/travelFashionTips.svg';
import adriaticoNewsImg from './images/adriaticoNews.png';
import gqImg from './images/gq.svg';
import corriereImg from './images/corriere.png';

export const pressPageProps = {
  links: [
    {
      imageUrl: corriereImg,
      imageAltText: 'Corriere della Sera',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.corriere.it/moda/21_giugno_15/lusso-affitto-piscina-privata-una-mezza-giornata-ma-che-un-ora-si-noleggia-un-app-c5a36b1a-cde2-11eb-8935-cc24dc80d17d.shtml',
      },
      text: 'Si chiama Swimmy e, dopo il successo riscosso in Francia e la Spagna, è arrivata anche in Italia. È già stata definita come l\'Airbnb del noleggio di piscine tra privati',
    },
    {
      imageUrl: vanityFair,
      imageAltText: 'Vanity Fair',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.vanityfair.it/viaggi-traveller/notizie-viaggio/2021/06/03/sognate-una-piscina-privata-per-una-mezza-giornata-o-anche-unora-si-affitta-su-swimmy',
      },
      text: 'Dopo la Francia e la Spagna, arriva in Italia Swimmy, l\'Airbnb del noleggio di piscine tra privati',
    },
    {
      imageUrl: gqImg,
      imageAltText: 'GQ',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.gqitalia.it/lifestyle/article/piscina-affitto-privati-swimmyy',
      },
      text: 'È appena sbarcato in Italia il nuovo «Airbnb delle piscine»: ecco come funziona, per prenotare subito una mini fuga nel cuore della città',
    },
    {
      imageUrl: wiredImg,
      imageAltText: 'Wired Italia',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.wired.it/lifestyle/sport/2021/04/27/swimmy-airbnb-piscine-italia/',
      },
      text: 'La piattaforma francese permette di noleggiare per un’ora o un’intera giornata una piscina privata. Per non dover aspettare la riapertura di quelle all’aperto, fissata per il 15 maggio.',
    },
    {
      imageUrl: giornalettismoImg,
      imageAltText: 'Giornalettismo',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.giornalettismo.com/swimmy-affitto-piscine-private-come-funziona/?fbclid=IwAR0uokkgtuBzJ5hiBDwFNCpTyzMbylA6chJ87RHP7z5GucJ439whwvAAxxQ',
      },
      text: 'Un progetto nato in Francia e di grande successo anche in Spagna. Attraverso la piattaforma è possibile affittare la propria piscina.',
    },
    {
      imageUrl: siViaggiaImg,
      imageAltText: 'Si Viaggia',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://siviaggia.it/notizie/noleggiare-piscina-mezza-giornata-swimmy/329202/',
      },
      text: 'Trascorrere l\'estate in piscina, anche solo per qualche ora: la soluzione per sentirsi in vacanza, anche quando non si è in vacanza.',
    },
    {
      imageUrl: donnaGlamourImg,
      imageAltText: 'Donna Glamour',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.donnaglamour.it/swimmy-noleggio-piscine-privati/lifestyle/',
      },
      text: 'Swimmy è la nuova piattaforma francese che consente di noleggiare piscine fra privati. Ecco come funziona.',
    },
    {
      imageUrl: viaggioOffImg,
      imageAltText: 'Viaggio Off',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.viaggioff.it/piscine-in-affitto-ora-ce-swimmy/',
      },
      text: 'In principio fu la condivisione di case, poi auto, barche. E ora arriva Swimmy. Si definisce l’Airbnb delle piscine private, e in effetti il concetto è quello della sharing economy: sulla piattaforma è possibile affittare una piscina per un giorno o anche solo per un’ora.',
    },
    {
      imageUrl: techPrincessImg,
      imageAltText: 'Tech Princess',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://techprincess.it/noleggio-piscine-private-swimmy/',
      },
      text: 'Arriva in Italia Swimmy, la piattaforma di noleggio piscine tra privati.',
    },
    {
      imageUrl: imbruttitoImg,
      imageAltText: 'Imbruttito',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://imbruttito.com/2021/05/17/citta-piscina-privata-trovi-arriva-swimmy-airbnb',
      },
      text: 'Città che vai, piscina privata che trovi: arriva "Swimmy", l\'Airbnb delle piscine che ci salverà dalla caldazza.',
    },
    {
      imageUrl: quotidianoDeSiciliaImg,
      imageAltText: 'Quotidiano di Sicilia',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://qds.it/vacanze-nasce-swimmy-la-airbnb-del-noleggio-piscine-tra-privati/',
      },
      text: 'Una piattaforma web per affittare la propria piscina o per trovarne facilmente una vicino geolocalizzandola magari vicino casa, evitando le affollate piscine pubbliche.',
    },
    {
      imageUrl: ramingareImg,
      imageAltText: 'Ramingare',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://ramingare.com/2021/05/31/swimmy-lairbnb-delle-piscine-private-arriva-in-italia/',
      },
      text: 'Dopo Francia e Spagna, l’AirBnb del noleggio di piscine Swimmy arriva anche in Italia, permettendo la condivisione con vicini o vacanzieri',
    },
    {
      imageUrl: travelFashionTipsImg,
      imageAltText: 'TravelFashionTips',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.travelfashiontips.com/2021/05/come-affittare-una-piscina-privata-con-swimmy.html',
      },
      text: 'Come affittare una piscina privata con Swimmy',
    },
    {
      imageUrl: adriaticoNewsImg,
      imageAltText: 'Adriatico News',
      linkProps: {
        type: 'ExternalLink',
        href:
          'http://www.adriaticonews.it/2021/05/24/swimmy-la-novita-dellestate-2021/',
      },
      text: 'Swimmy, la novità dell’estate 2021',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/SwimmySectionPress/pressConfig.js